import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Panel, Badge, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';

import { addLibraryPage } from '../store/actions';
import badgeClass from '../shared/document_badge';

function AvailablePages({ addLibraryPage, pages, locked }) {
  const panelOverflowCss = {
    maxHeight: '475px',
    overflowY: 'auto'
  };

  return (
    <div>
      {!locked && (
        <React.Fragment>
          <div className="my-3 d-flex align-items-center">
            <div  className="flex-grow">
              <strong>Available Pages</strong>
            </div>
          </div>
          {pages.length === 0 && (
            <div className="text-muted py-4 text-center">No results</div>
          )}
          {pages.length !== 0 && (
            <Panel style={panelOverflowCss}>
              <ul className="list-group">
                {pages.map(page => (
                  <li className="list-group-item" key={page.id}>
                    <Row className="row-eq-height">
                      <Col xs={3}>
                        {page.name}
                      </Col>
                      <Col xs={6}>
                        {page.user_label && (
                          <Badge className={`document-badge ${badgeClass('user_label')} mr-3`}>{page.user_label}</Badge>
                        )}
                        {page.size && (
                          <Badge className={`document-badge ${badgeClass('size', page.size)} mr-3`}>{page.size}</Badge>
                        )}
                      </Col>
                      <Col className="text-right" xs={3}>
                        <FontAwesomeIcon
                          className="text-success clickable ml-4"
                          icon={faPlusCircle}
                          name="add-page"
                          onClick={() => addLibraryPage(page.id)}
                        />
                      </Col>
                    </Row>
                  </li>
                ))}
              </ul>
            </Panel>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

AvailablePages.propTypes = {
  addLibraryPage: PropTypes.func.isRequired,
  allAvailablePages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })),
  locked: PropTypes.bool,
  pages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
};

const mapStateToProps = ({ availablePages, formData }) => {
  const documentTemplateAvailablePageIds = formData.availablePageTemplateTreeIds || [];
  const pages = availablePages.filter(page => !documentTemplateAvailablePageIds.map(p => p.id).includes(page.id));

  return { pages };
};

export default connect(mapStateToProps, { addLibraryPage })(AvailablePages);
